import { render } from "./Kakunin.vue?vue&type=template&id=3424dfcf&scoped=true"
import script from "./Kakunin.vue?vue&type=script&lang=js"
export * from "./Kakunin.vue?vue&type=script&lang=js"

import "./Kakunin.vue?vue&type=style&index=0&id=3424dfcf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3424dfcf"

export default script